/*
	Page Scripts Entry
*/
console.log('Initializing javascript...');

import Router from 'App/router';

/*
	Kick off FE Routing
*/
new Router();
console.log('Index JS loaded CHANGED');
